<template>
  <div v-if="params.value !== undefined" class="ag-table-cell-value-wrapper">
    <div class="ag-table-device-type-renderer-wrapper">
      <div class="ag-table-cell-value ag-table-device-type-renderer">
        <div class="ag-table-device-type-renderer__icon">
          <app-icon :name="type.icon"
                    :key="type.icon"
                    :style="{color: `rgba(var(--app-${type.icon_color}), 1)`}" size="20px"/>
        </div>
        <div class="ag-table-device-type-renderer__texts">
          <div class="ag-table-device-type-renderer__title">{{type.name}}</div>
          <div class="ag-table-device-type-renderer__subtitle" v-if="factoryNumber !== null">№ {{factoryNumber}}</div>
        </div>
      </div>
      <div class="link-icon ag-table-device-type-renderer-wrapper__edit" v-if="params.canEdit !== false && $can('rp.devices', 'write')" @click.prevent="onEditClick">
        <app-icon name="PenIcon" size="20px" />
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';

  export default Vue.extend({
    name: "DeviceTypeRenderer",
    computed: {
      device(){
        return this.params.data;
      },
      type() {
        return this.$store.getters['common/devices/typeById'](this.device.type);
      },
      factoryNumber(){
        return this.device.factory_number;
      }
    },
    methods: {
      onEditClick(){
        this.params.openEdit();
      }
    }
  })
</script>

<style lang="scss">
  .ag-table-device-type-renderer{
    display: flex;
    justify-content: flex-start;

    &__icon{
      flex-shrink: 0;
      margin-right: .5rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &__texts{
      text-align: left;
    }

    &__title{
      line-height: 1.1;
      white-space: nowrap;
    }

    &__subtitle{
      line-height: 1.1;
      font-size: 11px;
      margin-top: 4px;
    }
  }

  .ag-table-device-type-renderer-wrapper{
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;

    &__edit{
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
</style>
